module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"Under construction":"Im Wartungsmodus","check if the maintenance is done":"prüfen, ob die Wartungsarbeiten abgeschlossen sind"}}')
  delete Component.options._Ctor
}
